import { render } from "./Minus.vue?vue&type=template&id=08f6418e"
const script = {}
script.render = render

export default script